/* eslint-disable react-hooks/exhaustive-deps */
// @n8tb1t/use-scroll-position
import { useRef, useLayoutEffect } from 'react';

export interface Position {
  x: number;
  y: number;
}

interface Positions {
  currPos: Position;
  prevPos: Position;
}

const isBrowser = typeof window !== `undefined`;

function getScrollPosition({ element, useWindow }: any) {
  if (!isBrowser) return { x: 0, y: 0 };

  const target = element && element.current ? element.current : document.body;
  const position = target.getBoundingClientRect();

  return useWindow ? { x: window.scrollX, y: window.scrollY } : { x: position.left, y: position.top };
}

export function useScrollPosition(
  effect: ({ prevPos, currPos }: Positions) => void,
  deps: any[],
  element: any,
  useWindow: boolean,
  wait: number
) {
  const position = useRef(getScrollPosition({ useWindow }));

  let throttleTimeout: number | null = null;

  const callBack = () => {
    const currPos = getScrollPosition({ element, useWindow });
    effect({ prevPos: position.current, currPos });
    position.current = currPos;
    throttleTimeout = null;
  };

  useLayoutEffect(() => {
    if (!isBrowser) {
      return;
    }

    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          // @ts-ignore
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, deps);
}
